import React from "react";
import _ from 'i18n';
import { formatAmount, formatNumber } from "../../../../services/utils";
import { CommonLoader } from "../../../common/CommonLoader";



const EventLineChartDetails = ({ data, fetching, isError, type, chartLinesToShow }) => {

  const calculateTotal = () => {
    return data.reduce((tot, record) => {

      return chartLinesToShow.reduce((LineTotal, line) => {
        return tot + record[line];
      }, tot);

      //return tot + record.formations + record.cycles + record.saisons + record.premium + record.congrès;
    }, 0);
  };

  return (
    <div>
      {(fetching === false && isError === false) ? (
        <div className={'chart-registrant-number'}>
          {type === 'CA' ? formatAmount(calculateTotal()) : formatNumber(calculateTotal())}
        </div>) : (
        <CommonLoader containerHeight={"40px"} iconFontSize={"20px"}
          iconColor={"#29394D"} />)
      }
      <div className={'chart-registrant-number-label mb-2'}>
        {type === 'REGISTRATION' ? _('REGISTRATIONS_TOTAL_NUMBER') : _('CA_TOTAL_NUMBER')}
      </div>
      {/*<div className={'chart-registrant-period'}>Vos analyses commencent à partir de 01/01/2021</div>*/}
    </div>
  );
};







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartDetails.js